"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortHeader = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./SortHeader.scss");
var SortHeader = function (props) { return (react_1.default.createElement("div", { className: classnames_1.default('column', props.className, 'sort-header', 'th'), onClick: function () { return props.onClick(props.sortKey); } },
    react_1.default.createElement("span", null, props.text),
    react_1.default.createElement("span", null, props.sortKey === props.currentSortKey ?
        (react_1.default.createElement("i", { className: classnames_1.default('fas', { 'fa-sort-down': props.currentSortDirection === -1, 'fa-sort-up': props.currentSortDirection === 1 }) })) :
        (react_1.default.createElement("i", { className: "fas fa-sort" }))))); };
exports.SortHeader = SortHeader;
